//let fetchImp;
//import ('node-fetch')
//    .then(f=>fetchImp=f.default)
//    .catch(fetchImp=(typeof fetch !== 'undefined')? fetch: null);

class APICallWrapper {

    #fetchFun; 

    #defaultFetchFun;

    #listeners = [];

    token = null;

    constructor() {
        // need to bind to window as we will be calling via this.#fetchFun
        this.#defaultFetchFun = ((typeof fetch) !== 'undefined')? fetch.bind(window): null;
        this.#fetchFun;
        if (null === this.#defaultFetchFun) {
            this.setFetch(messageID => ({ Result: "Some response to '" + messageID + "' (no fetch api)", Status: "OK", Text: "Dummy response" }));
        } else {
            this.#fetchFun = this.#defaultFetchFun;
        }
    }

    addLogCallback(logCallback) {

        if (5 < this.#listeners.length) {
            throw new Error('Too many listeners on API');
        }

        if (!this.#listeners.includes(logCallback)){
            this.#listeners.push(logCallback);
        }
    }

    removeLogCallback(logCallback) {
        const index = this.#listeners.indexOf(logCallback);
        if (-1 !== index) {
            this.#listeners.splice(index, 1);
        }
    }

    setFetch(fetchFun) {

        if (!fetchFun) {
            this.#fetchFun = this.#defaultFetchFun;
        } else {
            this.#fetchFun = (url, dataOptions) => {

                const body = JSON.parse(dataOptions.body);
                const messageID = body.MessageID;
                const params = body.params;
                const result_ = fetchFun(messageID, params);
                
                const result = {
                    ok: true,
                    body: JSON.stringify(result_),
                    json: () => Promise.resolve(result_),
                };

                return Promise.resolve(result);
            };
        }
    }

    transact(messageID, method, url, params) {


        const result = this.#makeResultPromise(this.#callAPI, messageID, method, url, params);

        return result
    };

    /**
    * Takes an array of File objects and uploads them to the Web API. The files
    * could have come from an upload form or a Drag and Drop.
    * @param {Array}    files an Array of File objects
    * @param {int}      caseID An identifier for the patient case. This might 
    *                   have been returned from a call to saveReferralForm.
    * @param {int}      facilityID An identifier for the clinic, usually inputted from the clinic profile.
    * @param {int}      documentCategoryID An identifier for the document category.
    * @returns {Promise}
    */
    uploadFiles(fileUploadURL, files, caseID = 0, facilityID = 0, documentCategoryID = 0) {

       const result = this.#makeResultPromise(this.#sendFilesAPI, null, 'POST', fileUploadURL, { Files: files, CaseID: caseID, FacilityID: facilityID, DocumentCategoryID: documentCategoryID });
       return result;

       //return this.#sendFilesAPI(
       //    fileUploadURL,
       //    { Files: files, CaseID: caseID }
       //);
    };

    /**
    * Takes an array of File objects and uploads them to the Web API. The files
    * could have come from an upload form or a Drag and Drop.
    * @param {Array}    files an Array of File objects
    * @param {int}      caseID An identifier for the patient case. This might 
    *                   have been returned from a call to saveReferralForm.
    * @param {int}      facilityID An identifier for the clinic, usually inputted from the clinic profile.
    * @param {int}      documentCategoryID An identifier for the document category.
    * @returns {Promise}
    */
    downloadFile(fileDownloadURL, GUID) {

       const result = this.#downloadFileAPI(
         fileDownloadURL,
         { GUID: GUID }
       );
       return result;
    };

    #callAPI(messageID, method, url, params) {

        const requestData = {};
        requestData.MessageID = messageID;
        requestData.params = params;

        const dataSt = JSON.stringify(requestData);

        const headers = { 'Content-Type': 'application/json' };

        if (this.token) {
            headers.Token = this.token;
        }

        return this.#fetchFun(url, {
            method: method,
            mode: 'cors',
            cache: 'no-cache',
            headers: headers,
            redirect: 'error',
            referPolicy: 'origin-when-cross-origin',
            credentials: 'omit',
            body: dataSt
        });
    };

    #sendFilesAPI(messageID, method, url, params) {

        const {
          Files: files,
          CaseID: caseID,
          FacilityID: facilityID,
          DocumentCategoryID: documentCategoryID,
        } = params;

        const formData = new FormData();

        /* Add the files to the form data.
        Prefer the for loop and files.item as the 
        files are technically a FileList object rather 
        than an array */
        for (let i = 0; i < files.length; i++) {
            const file = files.item(i);
            formData.append('Files', file);
        }

        if (caseID) {
            formData.append('CaseID', caseID);
        }

        if (facilityID) {
            formData.append("FacilityID", facilityID);
        }

        if (documentCategoryID) {
            formData.append("DocumentCategoryID", documentCategoryID);
        }

        //const headers = { 'Content-Type': 'multipart/form-data' }
        /* Don't set content type to multipart/form-data as fetch does this and sets 
         * the boundary token */
        const headers = new Headers();
        if (this.token) {
            headers.append("Token", this.token);
        }

        return this.#fetchFun(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: headers,
            redirect: 'error',
            referPolicy: 'origin-when-cross-origin',
            credentials: 'omit',
            body: formData
        });
    };

    #downloadFileAPI(url, params) {

        const { GUID: guid } = params;

        const headers = new Headers();
        if (this.token) {
            headers.append("Token", this.token);
        }
        headers.append('id', guid)

        return this.#fetchFun(url, {
            method: 'GET',
            mode: 'cors',
            cache: 'no-cache',
            headers: headers,
            redirect: 'error',
            referPolicy: 'origin-when-cross-origin',
            credentials: 'omit'
        });
    };

    #runCallBacks(apiResult) {

        let result = apiResult;
        this.#listeners.forEach( l =>{ 
            const listnerResult = l( apiResult );
            result = listnerResult?? result;
        } );

        return result;
    };

    #makeResultPromise (apiCallFunction, messageID, method, url, params) {

        // to get an idea of how long API calls take
        const startTime = Date.now();

        const result = new Promise(
            (resolve, reject) => {

                /* wrap the reject as we call it in three places and need to do the 
                logCallback */
                const doReject = (err) => {
                    // calbacks can modify the error result
                    const modError = this.#runCallBacks(err);

                    reject(modError);
                }
                apiCallFunction.call(this, messageID, method, url, params)
                    .then(response => {

                        return response.ok ?
                            response.json() :
                            {
                                httpStatus: response.status,
                                httpStatusText: response.statusText,
                                Status: 'HTTP Err ' + response.status +
                                    ' ' + response.statusText
                            }
                    })
                    .then(json => {

                        // roughly the number of muliseconds it took to get an answer
                        const callTime = Date.now() - startTime

                        const status = 'OK' === json.Status
                        if (status) {

                            let result = new APIResonse(messageID, method, url, params)

                            result.networkOK = true
                            result.apiOK = status
                            result.apiStatus = json.Status
                            result.apiResult = json.Result
                            result.apiMetadata = json.Metadata
                            result.apiRecordCount = json.RecordCount
                            result.callDurationMs = callTime;

                            // calbacks can modify the error result
                            const modResult = this.#runCallBacks(result);

                            resolve(modResult);

                        } else if (json.httpStatus) {

                            const errTxt = 'Couldn\'t connect to API endpoint. HTTP Status ' +
                                json.httpStatus + ' (' + json.httpStatusText + ')'

                            const err = new APIError(messageID, method, url, params, errTxt)
                            err.callDurationMs = callTime

                            doReject(err)

                        } else {

                            const err = new APIError(messageID, method, url, params, json.Text)

                            err.networkOK = true
                            err.apiOK = status
                            err.apiStatus = json.Status
                            err.apiResult = json.Result
                            err.apiMetadata = json.Metadata
                            err.apiRecordCount = json.RecordCount
                            err.callDurationMs = callTime

                            doReject(err)
                        }
                    }).catch(
                        error => {

                            const errTxt = 'Couldn\'t connect to API endpoint. Network problem';

                            doReject(new APIError(messageID, method, url, params,
                                'Couldn\'t connect to API endpoint. ' + error))
                        }
                    )
            }
        );

        return result;
    };
}

class APIResonse {

    constructor(messageID, method, url, params) {
        this.requestMessageID = messageID
        this.requestEndpoint = url
        this.requestHTTPMethod = method
        this.requestParams = params

        delete params?.password                  // clear the PW to avoid copies
    }

    networkOK = false
    apiOK = false
    apiStatus = null
    apiResult = null
    apiText = null
    apiMetadata = null
    apiRecordCount = 0

    userErrorMessage = null

    requestEndpoint = null
    requestHTTPMethod = null
    requestMessageID = null
    requestParams = null
}

class APIError extends APIResonse {

    message = '';

    constructor(messageID, method, url, params, message) {
        super(messageID, method, url, params);

        this.apiText = message;
        this.message = message;
    }
};

export default APICallWrapper;
export {APIError, APIResonse};
